import hcAxios, { RequestOptions } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 直播间管理API
enum API {
  // 查询直播间详情
  LiveRoomGetLiveRoom = '/hk-web/liveRoom/getLiveRoom',
  // 查询直播间列表
  LiveRoomLiveRoomListByParams = '/hk-web/liveRoom/liveRoomListByParams',
  // 创建直播间
  LiveRoomCreateLiveRoom = '/hk-web/liveRoom/createLiveRoom',
  // 大喇叭
  LiveRoomLoudspeaker = '/hk-web/liveRoom/loudspeaker',
  // 下架直播间
  LiveRoomOffLiveRoom = '/hk-web/liveRoom/offLiveRoom',
  // 更新直播间
  LiveRoomUpdateLiveRoom = '/hk-web/liveRoom/updateLiveRoom',
  // 管理员禁言+封禁(踢人)
  LiveRoomAdminForbid = '/hk-web/liveRoom/admin/forbid',
  // 举报
  LiveRoomReport = '/hk-web/liveRoom/report',
  // 查询直播间列表
  LiveRoomGetLiveRoomList = '/hk-web/liveRoom/getLiveRoomList',
  // 埋点-跟单点击
  LiveRoomTrackingFollowOrder = '/hk-web/liveRoom/tracking/followOrder',
  // 查询直播间列表无分页
  LiveRoomNoPageGetLiveRoomList = '/hk-web/liveRoom/noPage/getLiveRoomList',
  // 查询待直播和直播中直播间列表
  LiveRoomLivePlayingList = '/hk-web/liveRoom/livePlayingList',
  // 查询直播Banner列表
  LiveBanners = '/hk-web/live/banners',
  // 直播间创建IM群组并返回GroupId
  LiveRoomCreateIMGroup = '/hk-web/liveRoom/createIMGroup',
  // 获取大喇叭
  LiveRoomGetLoudspeaker = '/hk-web/liveRoom/get/loudspeaker',
  // 查询当前主播最新直播间详情
  LiveRoomGetLatestLiveRoom = '/hk-web/liveRoom/getLatestLiveRoom',
}

export type TGetLiveRoomGetLiveRoomParams = {
  id?: any // id
}
export type TGetLiveRoomGetLiveRoomResponse = TResponse<{
  anchorPopular?: number // 主播热度
  chatRoomId?: string // IM聊天室ID
  copyTradingAmt?: number // 带单金额
  copyTradingCvr?: number // 带单转化率，26.32%返回26.32
  coverImageDay?: string // 日间封面图URL
  coverImageNight?: string // 夜间封面图URL
  createBy?: string // 创建直播的管理员UID
  createTime?: number // 直播间创建时间
  customJump?: number // 是否自定义跳转 0-否 1-是
  description?: string // 直播间简介
  endTime?: number // 结束时间
  flvUrl?: string // FLV播放地址URL
  followClicks?: number // 跟单点击
  followUsers?: number // 跟单人数
  forbidStatus?: number // 直播间禁言状态 0-关闭,1-开启
  hlsUrl?: string // HLS播放地址URL
  id?: number // 直播间ID
  jumpAndroid?: string // Android链接
  jumpIcon?: string // 跳转按钮图标
  jumpIos?: string // iOS链接
  jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
  jumpUrl?: string // 跳转链接
  kolFollow?: number // KOL是否为带单员 0-否 1-是
  lang?: string // 直播间语言，中文或非中文
  likeCount?: number // 直播间点赞数
  loudspeaker?: string // 大喇叭
  notice?: string // 直播间公告
  obsServer?: string // 推流地址:OBS服务器ID
  obsStreamKey?: string // 推流地址:OBS推流码
  photo?: string // 头像
  remark?: string // 下架直播备注，包含详细信息及操作人
  roomName?: string // 直播间名称
  roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
  rtmpUrl?: string // RTMP播放地址URL
  show?: string[] // 展示项配置
  sort?: number // 排序，数字越小排序越靠前
  startTime?: number // 开播时间
  status?: number // 直播状态，待开播/直播中/直播结束/下架直播
  tradeAmountLimit?: string // 30天现货+合约交易额
  updateTime?: number // 直播间更新时间
  userId?: number // 用户UID，关联用户表
  userName?: string // 用户昵称
  viewCount?: number // 直播间观看人次
  viewPersonCount?: number // 直播间观看人数
  virtualMax?: number // 虚拟人数,倍数范围上限
  virtualMin?: number // 虚拟人数,倍数范围下限
  webrtcUrl?: string // WebRTC播放地址URL
}>
export const getLiveRoomGetLiveRoom = (params?: TGetLiveRoomGetLiveRoomParams, options?: RequestOptions) => {
  return hcAxios.get<TGetLiveRoomGetLiveRoomResponse>(API.LiveRoomGetLiveRoom, { params, options })
}

export type TPostLiveRoomLiveRoomListByParamsParams = {
  endTime?: number // 结束时间
  id?: number // 直播间id
  lang?: string // 直播间语言
  orders?: {
    asc?: boolean
    column?: string
  }[]
  pageNum?: number
  pageSize?: number
  roomName?: string // 直播间名称
  roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
  startTime?: number // 开始时间
  status?: number // 直播间状态
  statusList?: number[] // 直播间状态
  userId?: number // 用户UID
  userName?: string // 用户昵称
}
export type TPostLiveRoomLiveRoomListByParamsResponse = TResponse<
  {
    anchorPopular?: number // 主播热度
    chatRoomId?: string // IM聊天室ID
    copyTradingAmt?: number // 带单金额
    copyTradingCvr?: number // 带单转化率，26.32%返回26.32
    coverImageDay?: string // 日间封面图URL
    coverImageNight?: string // 夜间封面图URL
    createBy?: string // 创建直播的管理员UID
    createTime?: number // 直播间创建时间
    customJump?: number // 是否自定义跳转 0-否 1-是
    description?: string // 直播间简介
    endTime?: number // 结束时间
    flvUrl?: string // FLV播放地址URL
    followClicks?: number // 跟单点击
    followUsers?: number // 跟单人数
    forbidStatus?: number // 直播间禁言状态 0-关闭,1-开启
    hlsUrl?: string // HLS播放地址URL
    id?: number // 直播间ID
    jumpAndroid?: string // Android链接
    jumpIcon?: string // 跳转按钮图标
    jumpIos?: string // iOS链接
    jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
    jumpUrl?: string // 跳转链接
    kolFollow?: number // KOL是否为带单员 0-否 1-是
    lang?: string // 直播间语言，中文或非中文
    likeCount?: number // 直播间点赞数
    loudspeaker?: string // 大喇叭
    notice?: string // 直播间公告
    obsServer?: string // 推流地址:OBS服务器ID
    obsStreamKey?: string // 推流地址:OBS推流码
    photo?: string // 头像
    remark?: string // 下架直播备注，包含详细信息及操作人
    roomName?: string // 直播间名称
    roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
    rtmpUrl?: string // RTMP播放地址URL
    show?: string[] // 展示项配置
    sort?: number // 排序，数字越小排序越靠前
    startTime?: number // 开播时间
    status?: number // 直播状态，待开播/直播中/直播结束/下架直播
    tradeAmountLimit?: string // 30天现货+合约交易额
    updateTime?: number // 直播间更新时间
    userId?: number // 用户UID，关联用户表
    userName?: string // 用户昵称
    viewCount?: number // 直播间观看人次
    viewPersonCount?: number // 直播间观看人数
    virtualMax?: number // 虚拟人数,倍数范围上限
    virtualMin?: number // 虚拟人数,倍数范围下限
    webrtcUrl?: string // WebRTC播放地址URL
  }[]
>
export const postLiveRoomLiveRoomListByParams = (
  params?: TPostLiveRoomLiveRoomListByParamsParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostLiveRoomLiveRoomListByParamsResponse>(API.LiveRoomLiveRoomListByParams, params, { options })
}

export type TPostLiveRoomCreateLiveRoomParams = {
  chatRoomId?: string // IM聊天室ID
  coverImageDay?: string // 日间封面图URL
  coverImageNight?: string // 夜间封面图URL
  createBy?: string // 创建直播的管理员UID
  customJump?: number // 是否自定义跳转 0-否 1-是
  description?: string // 直播间简介
  endTime?: number // 结束时间
  flvUrl?: string // FLV播放地址URL
  hlsUrl?: string // HLS播放地址URL
  jumpAndroid?: string // Android链接
  jumpIcon?: string // 跳转按钮图标
  jumpIos?: string // iOS链接
  jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
  jumpUrl?: string // 跳转链接
  kolFollow?: number // KOL是否为带单员 0-否 1-是
  lang?: string // 语言
  notice?: string // 直播间公告
  obsServer?: string // 推流地址:OBS服务器ID
  obsStreamKey?: string // 推流地址:OBS推流码
  remark?: string // 下架直播备注
  roomName?: string // 直播间名称
  roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
  rtmpUrl?: string // RTMP播放地址URL
  showConfig?: string // 配置推送入口(展示项配置，0-首页弹窗 1-行情底部tab动效（默认展示）2-行情顶部直播旁动效（默认展示）3-行情下方滚动推荐位 4-合约交易右上角入口 5-是否站内信通知 6-热币严选 7-客服悬浮入口) 0-关闭 1-开启 例子(开启付费tab动效和合约交易右上角): 0,1,0,0,1,0,0,0
  sort?: number // 排序
  startTime?: number // 开播时间
  status?: number // 直播状态
  tradeAmountLimit?: string // 30天现货+合约交易额
  userId?: number // 用户UID
  userName?: string // 用户昵称
  virtualMax?: number // 虚拟人数,倍数范围上限
  virtualMin?: number // 虚拟人数,倍数范围下限
  webrtcUrl?: string // WebRTC播放地址URL
}
export type TPostLiveRoomCreateLiveRoomResponse = TResponse<boolean>
export const postLiveRoomCreateLiveRoom = (params?: TPostLiveRoomCreateLiveRoomParams, options?: RequestOptions) => {
  return hcAxios.post<TPostLiveRoomCreateLiveRoomResponse>(API.LiveRoomCreateLiveRoom, params, { options })
}

export type TPostLiveRoomLoudspeakerParams = {
  msg?: string // 大喇叭消息
}
export type TPostLiveRoomLoudspeakerResponse = TResponse<boolean>
export const postLiveRoomLoudspeaker = (params?: TPostLiveRoomLoudspeakerParams, options?: RequestOptions) => {
  return hcAxios.post<TPostLiveRoomLoudspeakerResponse>(API.LiveRoomLoudspeaker, params, { options })
}

export type TPostLiveRoomOffLiveRoomParams = {
  code?: string
  id?: number
  remark?: string
}
export type TPostLiveRoomOffLiveRoomResponse = TResponse<boolean>
export const postLiveRoomOffLiveRoom = (params?: TPostLiveRoomOffLiveRoomParams, options?: RequestOptions) => {
  return hcAxios.post<TPostLiveRoomOffLiveRoomResponse>(API.LiveRoomOffLiveRoom, params, { options })
}

export type TPostLiveRoomUpdateLiveRoomParams = {
  chatRoomId?: string // IM聊天室ID
  coverImageDay?: string // 日间封面图URL
  coverImageNight?: string // 夜间封面图URL
  customJump?: number // 是否自定义跳转 0-否 1-是
  description?: string // 直播间简介
  endTime?: number // 结束时间
  flvUrl?: string // FLV播放地址URL
  hlsUrl?: string // HLS播放地址URL
  id?: number // 直播间ID
  jumpAndroid?: string // Android链接
  jumpIcon?: string // 跳转按钮图标
  jumpIos?: string // iOS链接
  jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
  jumpUrl?: string // 跳转链接
  kolFollow?: number // KOL是否为带单员 0-否 1-是
  lang?: string // 语言
  notice?: string // 直播间公告
  obsServer?: string // 推流地址:OBS服务器ID
  obsStreamKey?: string // 推流地址:OBS推流码
  remark?: string // 下架直播备注
  roomName?: string // 直播间名称
  rtmpUrl?: string // RTMP播放地址URL
  showConfig?: string // 配置推送入口(展示项配置，0-首页弹窗 1-行情底部tab动效（默认展示）2-行情顶部直播旁动效（默认展示）3-行情下方滚动推荐位 4-合约交易右上角入口 5-是否站内信通知) 0-关闭 1-开启 例子(开启付费tab动效和合约交易右上角): 0,1,0,0,1,0
  sort?: number // 排序
  startTime?: number // 开播时间
  status?: number // 直播状态
  tradeAmountLimit?: string // 30天现货+合约交易额
  updateBy?: string
  userId?: number // 用户UID
  userName?: string // 用户昵称
  virtualMax?: number // 虚拟人数,倍数范围上限
  virtualMin?: number // 虚拟人数,倍数范围下限
  webrtcUrl?: string // WebRTC播放地址URL
}
export type TPostLiveRoomUpdateLiveRoomResponse = TResponse<boolean>
export const postLiveRoomUpdateLiveRoom = (params?: TPostLiveRoomUpdateLiveRoomParams, options?: RequestOptions) => {
  return hcAxios.post<TPostLiveRoomUpdateLiveRoomResponse>(API.LiveRoomUpdateLiveRoom, params, { options })
}

export type TPostLiveRoomAdminForbidParams = {
  createBy?: number
  forbidTime?: number // 禁言时间(分钟)
  forbidType?: number // 禁止类型(1-禁言,2-封禁(群成员封禁))
  roomId?: number // 直播间id
  userIds?: number[] // 禁言用户,Uid逗号隔开
  userNickNames?: string[] // 禁言用户,昵称逗号隔开
}
export type TPostLiveRoomAdminForbidResponse = TResponse<any>
export const postLiveRoomAdminForbid = (params?: TPostLiveRoomAdminForbidParams, options?: RequestOptions) => {
  return hcAxios.post<TPostLiveRoomAdminForbidResponse>(API.LiveRoomAdminForbid, params, { options })
}

export type TPostLiveRoomReportParams = {
  reportedId?: number // 被举报人ID
  reporterId?: number // 举报人ID
  roomId?: number // 直播间id
}
export type TPostLiveRoomReportResponse = TResponse<any>
export const postLiveRoomReport = (params?: TPostLiveRoomReportParams, options?: RequestOptions) => {
  return hcAxios.post<TPostLiveRoomReportResponse>(API.LiveRoomReport, params, { options })
}

export type TGetLiveRoomGetLiveRoomListParams = {
  endTime?: number // 结束时间
  id?: number // 直播间id
  lang?: string // 直播间语言
  orders?: {
    asc?: boolean
    column?: string
  }[]
  pageNum?: number
  pageSize?: number
  roomName?: string // 直播间名称
  startTime?: number // 开始时间
  status?: number // 直播间状态
  userId?: number // 用户UID
  userName?: string // 用户昵称
}
export type TGetLiveRoomGetLiveRoomListResponse = TResponse<
  {
    anchorPopular?: number // 主播热度
    chatRoomId?: string // IM聊天室ID
    copyTradingAmt?: number // 带单金额
    copyTradingCvr?: number // 带单转化率，26.32%返回26.32
    coverImageDay?: string // 日间封面图URL
    coverImageNight?: string // 夜间封面图URL
    createBy?: string // 创建直播的管理员UID
    createTime?: number // 直播间创建时间
    customJump?: number // 是否自定义跳转 0-否 1-是
    description?: string // 直播间简介
    endTime?: number // 结束时间
    flvUrl?: string // FLV播放地址URL
    followClicks?: number // 跟单点击
    followUsers?: number // 跟单人数
    forbidStatus?: number // 直播间禁言状态 0-关闭,1-开启
    hlsUrl?: string // HLS播放地址URL
    id?: number // 直播间ID
    jumpAndroid?: string // Android链接
    jumpIcon?: string // 跳转按钮图标
    jumpIos?: string // iOS链接
    jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
    jumpUrl?: string // 跳转链接
    kolFollow?: number // KOL是否为带单员 0-否 1-是
    lang?: string // 直播间语言，中文或非中文
    likeCount?: number // 直播间点赞数
    loudspeaker?: string // 大喇叭
    notice?: string // 直播间公告
    obsServer?: string // 推流地址:OBS服务器ID
    obsStreamKey?: string // 推流地址:OBS推流码
    photo?: string // 头像
    remark?: string // 下架直播备注，包含详细信息及操作人
    roomName?: string // 直播间名称
    roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
    rtmpUrl?: string // RTMP播放地址URL
    show?: string[] // 展示项配置
    sort?: number // 排序，数字越小排序越靠前
    startTime?: number // 开播时间
    status?: number // 直播状态，待开播/直播中/直播结束/下架直播
    tradeAmountLimit?: string // 30天现货+合约交易额
    updateTime?: number // 直播间更新时间
    userId?: number // 用户UID，关联用户表
    userName?: string // 用户昵称
    viewCount?: number // 直播间观看人次
    viewPersonCount?: number // 直播间观看人数
    virtualMax?: number // 虚拟人数,倍数范围上限
    virtualMin?: number // 虚拟人数,倍数范围下限
    webrtcUrl?: string // WebRTC播放地址URL
  }[]
>
export const getLiveRoomGetLiveRoomList = (params?: TGetLiveRoomGetLiveRoomListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetLiveRoomGetLiveRoomListResponse>(API.LiveRoomGetLiveRoomList, { params, options })
}

export type TPostLiveRoomTrackingFollowOrderParams = {
  id?: number // 直播间ID
  userId?: number
}
export type TPostLiveRoomTrackingFollowOrderResponse = TResponse<any>
export const postLiveRoomTrackingFollowOrder = (
  params?: TPostLiveRoomTrackingFollowOrderParams,
  options?: RequestOptions
) => {
  return hcAxios.post<TPostLiveRoomTrackingFollowOrderResponse>(API.LiveRoomTrackingFollowOrder, params, { options })
}

export type TGetLiveRoomNoPageGetLiveRoomListParams = {
  endTime?: any // 结束时间
  id?: any // 直播间id
  lang?: any // 直播间语言
  pageNum?: any
  pageSize?: any
  roomName?: any // 直播间名称
  roomType?: any // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
  startTime?: any // 开始时间
  status?: any // 直播间状态
  statusList?: any // 直播间状态
  userId?: any // 用户UID
  userName?: any // 用户昵称
}
export type TGetLiveRoomNoPageGetLiveRoomListResponse = TResponse<
  {
    anchorPopular?: number // 主播热度
    chatRoomId?: string // IM聊天室ID
    copyTradingAmt?: number // 带单金额
    copyTradingCvr?: number // 带单转化率，26.32%返回26.32
    coverImageDay?: string // 日间封面图URL
    coverImageNight?: string // 夜间封面图URL
    createBy?: string // 创建直播的管理员UID
    createTime?: number // 直播间创建时间
    customJump?: number // 是否自定义跳转 0-否 1-是
    description?: string // 直播间简介
    endTime?: number // 结束时间
    flvUrl?: string // FLV播放地址URL
    followClicks?: number // 跟单点击
    followUsers?: number // 跟单人数
    forbidStatus?: number // 直播间禁言状态 0-关闭,1-开启
    hlsUrl?: string // HLS播放地址URL
    id?: number // 直播间ID
    jumpAndroid?: string // Android链接
    jumpIcon?: string // 跳转按钮图标
    jumpIos?: string // iOS链接
    jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
    jumpUrl?: string // 跳转链接
    kolFollow?: number // KOL是否为带单员 0-否 1-是
    lang?: string // 直播间语言，中文或非中文
    likeCount?: number // 直播间点赞数
    loudspeaker?: string // 大喇叭
    notice?: string // 直播间公告
    obsServer?: string // 推流地址:OBS服务器ID
    obsStreamKey?: string // 推流地址:OBS推流码
    photo?: string // 头像
    remark?: string // 下架直播备注，包含详细信息及操作人
    roomName?: string // 直播间名称
    roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
    rtmpUrl?: string // RTMP播放地址URL
    show?: string[] // 展示项配置
    sort?: number // 排序，数字越小排序越靠前
    startTime?: number // 开播时间
    status?: number // 直播状态，待开播/直播中/直播结束/下架直播
    tradeAmountLimit?: string // 30天现货+合约交易额
    updateTime?: number // 直播间更新时间
    userId?: number // 用户UID，关联用户表
    userName?: string // 用户昵称
    viewCount?: number // 直播间观看人次
    viewPersonCount?: number // 直播间观看人数
    virtualMax?: number // 虚拟人数,倍数范围上限
    virtualMin?: number // 虚拟人数,倍数范围下限
    webrtcUrl?: string // WebRTC播放地址URL
  }[]
>
export const getLiveRoomNoPageGetLiveRoomList = (
  params?: TGetLiveRoomNoPageGetLiveRoomListParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetLiveRoomNoPageGetLiveRoomListResponse>(API.LiveRoomNoPageGetLiveRoomList, { params, options })
}

export type TGetLiveRoomLivePlayingListParams = any
export type TGetLiveRoomLivePlayingListResponse = TResponse<
  {
    anchorPopular?: number // 主播热度
    chatRoomId?: string // IM聊天室ID
    copyTradingAmt?: number // 带单金额
    copyTradingCvr?: number // 带单转化率，26.32%返回26.32
    coverImageDay?: string // 日间封面图URL
    coverImageNight?: string // 夜间封面图URL
    createBy?: string // 创建直播的管理员UID
    createTime?: number // 直播间创建时间
    customJump?: number // 是否自定义跳转 0-否 1-是
    description?: string // 直播间简介
    endTime?: number // 结束时间
    flvUrl?: string // FLV播放地址URL
    followClicks?: number // 跟单点击
    followUsers?: number // 跟单人数
    forbidStatus?: number // 直播间禁言状态 0-关闭,1-开启
    hlsUrl?: string // HLS播放地址URL
    id?: number // 直播间ID
    jumpAndroid?: string // Android链接
    jumpIcon?: string // 跳转按钮图标
    jumpIos?: string // iOS链接
    jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
    jumpUrl?: string // 跳转链接
    kolFollow?: number // KOL是否为带单员 0-否 1-是
    lang?: string // 直播间语言，中文或非中文
    likeCount?: number // 直播间点赞数
    loudspeaker?: string // 大喇叭
    notice?: string // 直播间公告
    obsServer?: string // 推流地址:OBS服务器ID
    obsStreamKey?: string // 推流地址:OBS推流码
    photo?: string // 头像
    remark?: string // 下架直播备注，包含详细信息及操作人
    roomName?: string // 直播间名称
    roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
    rtmpUrl?: string // RTMP播放地址URL
    show?: string[] // 展示项配置
    sort?: number // 排序，数字越小排序越靠前
    startTime?: number // 开播时间
    status?: number // 直播状态，待开播/直播中/直播结束/下架直播
    tradeAmountLimit?: string // 30天现货+合约交易额
    updateTime?: number // 直播间更新时间
    userId?: number // 用户UID，关联用户表
    userName?: string // 用户昵称
    viewCount?: number // 直播间观看人次
    viewPersonCount?: number // 直播间观看人数
    virtualMax?: number // 虚拟人数,倍数范围上限
    virtualMin?: number // 虚拟人数,倍数范围下限
    webrtcUrl?: string // WebRTC播放地址URL
  }[]
>
export const getLiveRoomLivePlayingList = (params?: TGetLiveRoomLivePlayingListParams, options?: RequestOptions) => {
  return hcAxios.get<TGetLiveRoomLivePlayingListResponse>(API.LiveRoomLivePlayingList, { params, options })
}

export type TGetLiveBannersParams = any
export type TGetLiveBannersResponse = TResponse<
  {
    endTime?: number // 结束时间
    id?: number // BannerID
    imgUrl?: string // 活动图片
    jumpLink?: string // 跳转链接
    jumpType?: number // 跳转类型 1-站内Code 2-活动链接 3-原生路由
    name?: string // 名称
    sortId?: number // 次序(最大排在最前)
    startTime?: number // 开始时间
    status?: number // 状态 0-关闭 1-开启
    updateBy?: string // 最后更新人
    updateTime?: number // 最后更新时间
  }[]
>
export const getLiveBanners = (params?: TGetLiveBannersParams, options?: RequestOptions) => {
  return hcAxios.get<TGetLiveBannersResponse>(API.LiveBanners, { params, options })
}

export type TGetLiveRoomCreateIMGroupParams = any
export type TGetLiveRoomCreateIMGroupResponse = TResponse<string>
export const getLiveRoomCreateIMGroup = (params?: TGetLiveRoomCreateIMGroupParams, options?: RequestOptions) => {
  return hcAxios.get<TGetLiveRoomCreateIMGroupResponse>(API.LiveRoomCreateIMGroup, { params, options })
}

export type TGetLiveRoomGetLoudspeakerParams = any
export type TGetLiveRoomGetLoudspeakerResponse = TResponse<string>
export const getLiveRoomGetLoudspeaker = (params?: TGetLiveRoomGetLoudspeakerParams, options?: RequestOptions) => {
  return hcAxios.get<TGetLiveRoomGetLoudspeakerResponse>(API.LiveRoomGetLoudspeaker, { params, options })
}

export type TGetLiveRoomGetLatestLiveRoomParams = {
  userId?: any // 主播用户UID
}
export type TGetLiveRoomGetLatestLiveRoomResponse = TResponse<{
  anchorPopular?: number // 主播热度
  chatRoomId?: string // IM聊天室ID
  copyTradingAmt?: number // 带单金额
  copyTradingCvr?: number // 带单转化率，26.32%返回26.32
  coverImageDay?: string // 日间封面图URL
  coverImageNight?: string // 夜间封面图URL
  createBy?: string // 创建直播的管理员UID
  createTime?: number // 直播间创建时间
  customJump?: number // 是否自定义跳转 0-否 1-是
  description?: string // 直播间简介
  endTime?: number // 结束时间
  flvUrl?: string // FLV播放地址URL
  followClicks?: number // 跟单点击
  followUsers?: number // 跟单人数
  forbidStatus?: number // 直播间禁言状态 0-关闭,1-开启
  hlsUrl?: string // HLS播放地址URL
  id?: number // 直播间ID
  jumpAndroid?: string // Android链接
  jumpIcon?: string // 跳转按钮图标
  jumpIos?: string // iOS链接
  jumpType?: number // 跳转类型 1-站内Code 2-站外链接 3-原生路由
  jumpUrl?: string // 跳转链接
  kolFollow?: number // KOL是否为带单员 0-否 1-是
  lang?: string // 直播间语言，中文或非中文
  likeCount?: number // 直播间点赞数
  loudspeaker?: string // 大喇叭
  notice?: string // 直播间公告
  obsServer?: string // 推流地址:OBS服务器ID
  obsStreamKey?: string // 推流地址:OBS推流码
  photo?: string // 头像
  remark?: string // 下架直播备注，包含详细信息及操作人
  roomName?: string // 直播间名称
  roomType?: number // 直播类型 1-KOL行情分析(默认) 2-投研 3-平台客服 4-项目方
  rtmpUrl?: string // RTMP播放地址URL
  show?: string[] // 展示项配置
  sort?: number // 排序，数字越小排序越靠前
  startTime?: number // 开播时间
  status?: number // 直播状态，待开播/直播中/直播结束/下架直播
  tradeAmountLimit?: string // 30天现货+合约交易额
  updateTime?: number // 直播间更新时间
  userId?: number // 用户UID，关联用户表
  userName?: string // 用户昵称
  viewCount?: number // 直播间观看人次
  viewPersonCount?: number // 直播间观看人数
  virtualMax?: number // 虚拟人数,倍数范围上限
  virtualMin?: number // 虚拟人数,倍数范围下限
  webrtcUrl?: string // WebRTC播放地址URL
}>
export const getLiveRoomGetLatestLiveRoom = (
  params?: TGetLiveRoomGetLatestLiveRoomParams,
  options?: RequestOptions
) => {
  return hcAxios.get<TGetLiveRoomGetLatestLiveRoomResponse>(API.LiveRoomGetLatestLiveRoom, { params, options })
}
